import {
  ModalSheet,
  ModalSheetContent,
  ModalSheetContentBlock,
  ModalSheetContentDescription,
  ModalSheetContentIllustration,
  ModalSheetContentTitle,
  ModalSheetFooter,
  ModalSheetFooterButtonGroup,
  ModalSheetFooterSpacer,
  ModalSheetHeader,
} from 'components/ModalSheet'
import * as React from 'react'
import Button from 'components/Button'
import BulkCopyJobsSuccessViewModel from './BulkCopyJobsSuccessViewModel'
import { observer } from 'mobx-react'

interface Props {
  vm: BulkCopyJobsSuccessViewModel
}

const BulkCopySuccessDialog = observer(({ vm }: Props) => {
  return (
    <ModalSheet showing={vm.showing} onRequestClose={vm.close}>
      <ModalSheetHeader withCloseButton />
      <ModalSheetContent>
        <ModalSheetContentBlock>
          <ModalSheetContentIllustration
            src={require('assets/images/img_milestone.svg')}
            alt="Clone Jobs"
          />
          <ModalSheetContentTitle>
            {vm.jobCount} Jobs were successfully cloned!
          </ModalSheetContentTitle>
          <ModalSheetContentDescription>
            You can now edit Legend's responses
          </ModalSheetContentDescription>
        </ModalSheetContentBlock>
      </ModalSheetContent>
      <ModalSheetFooter>
        <ModalSheetFooterSpacer />
        <ModalSheetFooterButtonGroup>
          <Button onClick={vm.close}>Close</Button>
          <Button
            onClick={vm.start}
            type="primary"
            dataTest="bulk-copy-jobs-success-modal-confirm"
          >
            Start
          </Button>
        </ModalSheetFooterButtonGroup>
      </ModalSheetFooter>
    </ModalSheet>
  )
})

export default BulkCopySuccessDialog
